import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { seoArticles } from '@/mocks/articles';

export default function SEOArticles() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-accent-600 text-xs font-medium mb-4 whitespace-nowrap">
            Artykuły SEO
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            {t('home.articles_title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t('home.articles_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium whitespace-nowrap backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-auto flex items-center justify-between">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{article.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 whitespace-nowrap group-hover:gap-2 transition-all">
                    {t('seo.read_more')}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}